import global from '@/utils/global'
import assets from '@/lang/asset.json'
import { CLIENT, FLP_USER_ACCESS_FLAG_KEY } from '@/constants'
const state = {
  // 是否为快递App
  isApp: CLIENT.FLP_USER_ACCESS_FLAG === +global.getCookie(FLP_USER_ACCESS_FLAG_KEY),
  dict: assets.dict
}

const getters = {
  isApp (state) {
    return state.isApp
  }
}

const mutations = {

}

export default {
  state,
  getters,
  mutations
}
